/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Chaitanya
*/

import React, { useState, useEffect } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import ItemDetail from '@components/global/ItemDetail';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import * as Layout from '@components/screen/Layout';
import { isWeb } from '@global/screens';
import { hasNoAccess } from '@global/helpers';
import useApi from '@/hooks/useApi';
import { MsAccount } from '@api/ms-account';
import StatusBadge from '@components/global/StatusBadge';
import { AUTOMATE_CREDIT_LIMIT } from '@/constants';

const CreditLimitDetailScreen = (props) => {
  const [detailData, setDetailData] = useState({});

  const getCreditLimitDetail = useApi(MsAccount.getCreditLimitDetail);

  const showEditButton = !hasNoAccess(['superadmin', 'general']);

  const getDetail = async (id) => {
    const response = await getCreditLimitDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      result.id = result._id;
      if (result.automate_credit_limit) {
        const CL = AUTOMATE_CREDIT_LIMIT.find(
          (val) => val.value == result.automate_credit_limit,
        );
        if (CL) {
          result.automate_credit_limit = CL.label;
        }
      }
      setDetailData(result);
    }
  };

  const goBack = () => {
    props.navigation.replace('CreditLimitDetailScreen', {});
    props.navigation.navigate('CreditLimitScreen');
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setDetailData({});
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  return (
    <Layout.Container>
      {getCreditLimitDetail?.loading ? (
        <Layout.Wrapper>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : detailData && Object.keys(detailData).length ? (
        <>
          {isWeb ? (
            <Layout.Wrapper white={false}>
              <Layout.Back
                title="Customer Credit Limit"
                onCallback={() => goBack()}
              />
            </Layout.Wrapper>
          ) : (
            false
          )}
          <Layout.Wrapper rounded>
            <ScrollView stickyHeaderIndices={isWeb ? [] : [0]}>
              <View style={styles.sectionWrapper}>
                {isWeb ? (
                  <View
                    style={[
                      styles.rowContainer,
                      {
                        position: 'relative',
                        zIndex: 1,
                        justifyContent: 'space-between',
                      },
                    ]}>
                    <SociollaText type="medium" style={{ fontSize: 20 }}>
                      Customer Credit Limit
                    </SociollaText>
                    {showEditButton ? (
                      <View style={{ position: 'relative' }}>
                        <Button
                          type="primary"
                          rounded
                          buttonStyle={{ width: 80, marginRight: 10 }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ color: Colors.white }}>
                              Edit
                            </SociollaText>
                          }
                          onPress={() =>
                            props.navigation.replace('CreditLimitFormScreen', {
                              id: detailData._id,
                              name: detailData.name ? detailData.name : '-',
                              titleScreen: detailData.name
                                ? detailData.name
                                : '-',
                            })
                          }
                        />
                      </View>
                    ) : (
                      false
                    )}
                  </View>
                ) : (
                  false
                )}
                <View
                  style={[
                    { maxWidth: isWeb ? 400 : '100%' },
                    isWeb ? { paddingVertical: 15 } : { paddingBottom: 20 },
                  ]}>
                  <ItemDetail
                    name="Name"
                    value={detailData.name ? detailData.name : '-'}
                  />
                  <ItemDetail
                    name="Description"
                    centered
                    value={
                      detailData.description ? detailData.description : '-'
                    }
                  />
                  <ItemDetail
                    name="Status"
                    centered
                    value={
                      <StatusBadge
                        status={detailData.is_active ? 'active' : 'in_active'}
                      />
                    }
                  />
                  <ItemDetail
                    name="Channel"
                    centered
                    value={
                      detailData.market_type?.code
                        ? detailData.market_type.code.toUpperCase()
                        : '-'
                    }
                  />
                  <ItemDetail
                    name="Payment Terms"
                    value={
                      detailData.payment_terms?.name
                        ? detailData.payment_terms.name
                        : '-'
                    }
                  />
                  <ItemDetail
                    name="Automate Credit Limit"
                    value={
                      detailData.automate_credit_limit
                        ? detailData.automate_credit_limit
                        : '-'
                    }
                  />
                </View>
              </View>
            </ScrollView>
          </Layout.Wrapper>
        </>
      ) : (
        false
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  sectionWrapper: { width: '100%', padding: 15 },
  rowContainer: { flexDirection: 'row', alignItems: 'center' },
});

export default CreditLimitDetailScreen;
